module.exports = __webpack_public_path__ + "img/parallax2-1200p.79a52b84.jpg";